const CHANNELS_PREFIX = '@CHANNELS';

export const FETCH = `${CHANNELS_PREFIX}/FETCH`;
export const FETCH_SUCCESS = `${CHANNELS_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${CHANNELS_PREFIX}/FETCH_ERROR`;

export const UPDATE_CURRENT_PROGRAM = `${CHANNELS_PREFIX}/UPDATE_CURRENT_PROGRAM`;
export const UPDATE_CURRENT_PROGRAM_SUCCESS = `${CHANNELS_PREFIX}UPDATE_CURRENT_PROGRAM_SUCCESS`;
export const UPDATE_CURRENT_PROGRAM_ERROR = `${CHANNELS_PREFIX}/UPDATE_CURRENT_PROGRAM_ERROR`;

export const TOGGLE_CHANNEL_IN_FAVORITE_STATUS = `${CHANNELS_PREFIX}/TOGGLE_CHANNEL_IN_FAVORITE_STATUS`;
export const TOGGLE_CHANNEL_IN_FAVORITE_STATUS_SUCCESS = `${CHANNELS_PREFIX}/TOGGLE_CHANNEL_IN_FAVORITE_STATUS_SUCCESS`;
export const TOGGLE_CHANNEL_IN_FAVORITE_STATUS_ERROR = `${CHANNELS_PREFIX}/TOGGLE_CHANNEL_IN_FAVORITE_STATUS_ERROR`;

export const TOGGLE_PROGRAM_IN_FAVORITE_STATUS = `${CHANNELS_PREFIX}/TOGGLE_PROGRAM_IN_FAVORITE_STATUS`;
export const TOGGLE_PROGRAM_IN_FAVORITE_STATUS_SUCCESS = `${CHANNELS_PREFIX}/TOGGLE_PROGRAM_IN_FAVORITE_STATUS_SUCCESS`;
export const TOGGLE_PROGRAM_IN_FAVORITE_STATUS_ERROR = `${CHANNELS_PREFIX}/TOGGLE_PROGRAM_IN_FAVORITE_STATUS_ERROR`;

export const FETCH_EPG = `${CHANNELS_PREFIX}/FETCH_EPG`;
export const FETCH_EPG_SUCCESS = `${CHANNELS_PREFIX}/FETCH_EPG_SUCCESS`;
export const FETCH_EPG_ERROR = `${CHANNELS_PREFIX}/FETCH_EPG_ERROR`;

export const FETCH_EXTRA_EPG_ITEMS = `${CHANNELS_PREFIX}/FETCH_EXTRA_EPG_ITEMS`;
export const FETCH_EXTRA_EPG_ITEMS_SUCCESS = `${CHANNELS_PREFIX}/FETCH_EXTRA_EPG_ITEMS_SUCCESS`;
export const FETCH_EXTRA_EPG_ITEMS_ERROR = `${CHANNELS_PREFIX}/FETCH_EXTRA_EPG_ITEMS_ERROR`;

export const RESET_ALL_DATA = `${CHANNELS_PREFIX}/RESET_ALL_DATA`;
